import { TERYT_URL } from '../core/constants';
import { terytHintEl, terytInput, terytSuggestEl } from '../dom/elements';
import { esc } from '../utils/formatters';
import { foldPl } from '../utils/string';

var powiatyList = [];
var terytByCode = {};
var terytSuggestRows = [];
var terytSuggestActive = -1;
var terytBlurTimer = null;

export function parseTerytFilterValue(value) {
    var raw = value == null ? '' : String(value).trim();
    if (!raw) return '';
    if (/^\d{4}$/.test(raw)) return raw;

    var folded = foldPl(raw);
    for (var i = 0; i < powiatyList.length; i++) {
        if (powiatyList[i]._search === folded) {
            return powiatyList[i].teryt;
        }
    }

    return '';
}

export function syncTerytHintFromInput() {
    if (!terytHintEl || !terytInput) return;

    var code = parseTerytFilterValue(terytInput.value);
    var row = code ? terytByCode[code] : null;
    terytHintEl.textContent = row ? (row.powiat + ' · woj. ' + row.wojewodztwo) : '';
}

function setSuggestOpen(open) {
    if (!terytSuggestEl) return;

    terytSuggestEl.hidden = !open;
    if (!open) {
        terytSuggestActive = -1;
    }
}

function renderTerytSuggestionButtons(rows) {
    if (!terytSuggestEl) return;

    terytSuggestRows = rows;
    if (!rows.length) {
        setSuggestOpen(false);
        terytSuggestEl.innerHTML = '';
        return;
    }

    terytSuggestEl.innerHTML = rows.map(function(row, index) {
        return '<button type="button" data-i="' + index + '" class="' + (index === terytSuggestActive ? 'is-active' : '') + '">' +
            '<span class="nm-suggest-code">' + esc(row.teryt) + '</span>' +
            '<span class="nm-suggest-main">' + esc(row.powiat) + '</span>' +
            '<span class="nm-suggest-sub">woj. ' + esc(row.wojewodztwo) + '</span>' +
        '</button>';
    }).join('');
    setSuggestOpen(true);
}

function pickPowiatFromSuggest(row) {
    if (!row || !terytInput) return;

    terytInput.value = row.teryt;
    syncTerytHintFromInput();
    renderTerytSuggestionButtons([]);
    terytInput.focus();
}

function refreshTerytSuggest(query) {
    var queryValue = foldPl(query).trim();
    if (!queryValue) {
        renderTerytSuggestionButtons([]);
        syncTerytHintFromInput();
        return;
    }

    var rows = [];
    for (var i = 0; i < powiatyList.length; i++) {
        if (powiatyList[i]._search.indexOf(queryValue) !== -1) {
            rows.push(powiatyList[i]);
        }
        if (rows.length >= 12) break;
    }

    terytSuggestActive = rows.length ? 0 : -1;
    renderTerytSuggestionButtons(rows);
}

export function setupTerytAutocomplete() {
    if (!terytInput || !terytSuggestEl || terytInput.dataset.ready === '1') return;
    terytInput.dataset.ready = '1';

    terytInput.addEventListener('input', function() {
        if (terytBlurTimer) clearTimeout(terytBlurTimer);
        refreshTerytSuggest(terytInput.value);
    });

    terytInput.addEventListener('focus', function() {
        if (terytBlurTimer) clearTimeout(terytBlurTimer);
        if (terytInput.value.trim()) refreshTerytSuggest(terytInput.value);
    });

    terytInput.addEventListener('blur', function() {
        terytBlurTimer = setTimeout(function() {
            setSuggestOpen(false);
            var code = parseTerytFilterValue(terytInput.value);
            if (code && terytByCode[code]) terytInput.value = code;
            syncTerytHintFromInput();
        }, 160);
    });

    terytInput.addEventListener('keydown', function(e) {
        var open = !terytSuggestEl.hidden;
        if (!open || !terytSuggestRows.length) return;

        if (e.key === 'ArrowDown') {
            e.preventDefault();
            terytSuggestActive = Math.min(terytSuggestActive + 1, terytSuggestRows.length - 1);
            renderTerytSuggestionButtons(terytSuggestRows);
        } else if (e.key === 'ArrowUp') {
            e.preventDefault();
            terytSuggestActive = Math.max(terytSuggestActive - 1, 0);
            renderTerytSuggestionButtons(terytSuggestRows);
        } else if (e.key === 'Enter') {
            e.preventDefault();
            if (terytSuggestRows[terytSuggestActive]) pickPowiatFromSuggest(terytSuggestRows[terytSuggestActive]);
        } else if (e.key === 'Escape') {
            setSuggestOpen(false);
        }
    });

    terytSuggestEl.addEventListener('mousedown', function(e) {
        var btn = e.target.closest('button[data-i]');
        if (!btn) return;

        e.preventDefault();
        var index = parseInt(btn.getAttribute('data-i'), 10);
        if (terytSuggestRows[index]) pickPowiatFromSuggest(terytSuggestRows[index]);
    });
}

export function fetchTerytPowiaty() {
    fetch(TERYT_URL)
        .then(function(r) { return r.json(); })
        .then(function(data) {
            if (!Array.isArray(data)) return;

            terytByCode = {};
            powiatyList = data.map(function(item) {
                item._search = foldPl((item.teryt || '') + ' ' + (item.powiat || '') + ' ' + (item.wojewodztwo || ''));
                terytByCode[item.teryt] = item;
                return item;
            });
            syncTerytHintFromInput();
        })
        .catch(function(err) { console.error('Pobieranie danych Krajowego Rejestru Urzędowego Podziału Terytorialnego Kraju nie powiodło się:', err); });
}
